import { createModel } from '@rematch/core';
import { selectors } from './selector';
import { RootState } from '../../store';
import { FacilityModel } from '../../models/facility';
import { storeData } from '../../utils/converter';
import {
    getFacilities,
    getOtherFacilities
} from '../../apis/facility';

export interface State {
    allIds: number[];
    byId: Dictionary<FacilityModel>;
    loading: Dictionary<boolean>;
}

export const facilities = createModel<State>({
    state: {
        allIds: [],
        byId: {},
        loading: {}
    },
    reducers: {
        update: (
            state: State,
            data: Undefinable<MixType<FacilityModel>>,
            loadingKey?: string
        ): State => {
            const byId = {
                ...state.byId,
                ...storeData(data, 'id')
            };
            return {
                ...state,
                allIds: Object.keys(byId)
                    .sort((a, b) => byId[a]!.name > byId[b]!.name ? 1 : -1)
                    .map(x => +x),
                byId: byId,
                ...loadingKey && {
                    loading: {
                        ...state.loading,
                        [loadingKey]: false
                    }
                }
            };
        },
        loading: (
            state: State,
            loadingKey: string,
            loading: boolean
        ): State => ({
            ...state,
            loading: {
                ...state.loading,
                [loadingKey]: loading
            }
        })
    },
    effects: () => ({
        async getFacilitiesAsync(ids: Undefinable<number>[], rootState: RootState) {
            const notExistedIds = selectors.getOtherFacilityIds(rootState.facilities, ids);
            if (notExistedIds.length > 0) {
                try {
                    const data = await getFacilities(notExistedIds);
                    this.update(data);
                } catch (e) {
                    window.console.log(e);
                }
            }
        },
        async getOtherFacilitiesAsync(_: {}, rootState: RootState) {
            const existedIds = selectors.getFacilityIds(rootState.facilities);
            try {
                const data = await getOtherFacilities(existedIds);
                this.update(data);
            } catch (e) {
                window.console.log(e);
            }
        }
    })
});
